<template>

    <section class="content_box_div">
        <div class="container-head container-header">
            <div class="head-info">
                <span v-if="showAlertsChart">Alerts Per Day</span>
                <span v-else>Number of Requests Per Day</span>
                <span v-if="isalertchart" @click="changeChart(showAlertsChart)">
                    <i class="material-icons">
                        swap_vertical_circle
                    </i>
                </span>
            </div>
        </div>

        <div class="chart-details">
            <div class="chart-content">
                <!-- <svg width="1100" height="300" id="svg-chart"></svg> -->
                <canvas id="alertsChart" width="550" height="150"></canvas>
            </div>
        </div>
    </section>

</template>

<script>
import Chart from 'chart.js';
import Vue from 'vue';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
export default {
    name: 'ChartPage',
    props: {
        isalertchart: {
            type: Boolean,
            defaults: false
        },
        apptoken: {
            type: String
        },
        nodeValue:{
            type: String
        }
    },
    data () {
        return {
            chartData: {},
            showAlertsChart: false,
            barLineChart: {},
            showNOData: false,
            hide:null
        }
    },
    watch: {
        isalertchart(){
            this.showAlertsChart = this.isalertchart;
            this.getChartData();
        }
    },
    mounted() {
        var self = this;
        self.getChartData();
    },
    methods: {
        changeChart(flagval){
            var self = this;
            self.showAlertsChart = !flagval;
            self.barLineChart.destroy();
            self.getChartData();
        }, 

        getChartData(){
            var self = this, url = '/alerts_count_graph_data/',
            end_date = new Date(),
            start_date = new Date();

            start_date = new Date(start_date.setDate(start_date.getDate()-7));

            url = self.showAlertsChart ?  url : '/requests_count_graph_data/';

            self.showNOData = false;
            showLoadIcon();
            this.$loading(true);
            Vue.http.get(url, {
                params:{
                    'query' : 'alerts_delivery_count',
                    'apptoken' : self.apptoken,
                    'steps' : '14',
                    'node' : self.nodeValue
                }
            })
            .then((res) => {
                try{
                    //sample Data..
                    if(self.showAlertsChart){
                        // res = {
                        //     "new": {
                        //         "1543498830.781": 0, 
                        //         "1543054230.781": 0, 
                        //         "1543059630.781": 0, 
                        //         "1543063230.781": 0, 
                        //         "1543498830.781": 0, 
                        //         "1543974930.781": 0, 
                        //         "1543984830.781": 0
                        //     }, 
                        //     "retrospective": {
                        //         "1543498830.781": 1216, 
                        //         "1543054230.781": 10, 
                        //         "1543059630.781": 10, 
                        //         "1543063230.781": 10, 
                        //         "1543498830.781": 1216, 
                        //         "1543974930.781": 3, 
                        //         "1543984830.781": 3
                        //     }, 
                        //     "total_count": {
                        //         "1543498830.781": 1216, 
                        //         "1543054230.781": 10, 
                        //         "1543059630.781": 10, 
                        //         "1543063230.781": 10, 
                        //         "1543498830.781": 1216, 
                        //         "1543974930.781": 3, 
                        //         "1543984830.781": 3
                        //     }
                        // };

                        let data = res['data'], dateLabels = [], newData = [], retroData = [], totalData = [];
                        self.chartData = data;

                        var allDates = Object.keys(data['total_count']);

                        for(let i in allDates){
                            if(allDates.hasOwnProperty(i)){
                                dateLabels.push(new Date(allDates[i]*1000).toDateString());
                                newData.push(data['new'][allDates[i]]);
                                retroData.push(data['retrospective'][allDates[i]]);
                                totalData.push(data['total_count'][allDates[i]]);
                            }
                        }
                        self.drawAlertsChart(dateLabels, newData, retroData, totalData);

                    }else{
                        
                        // res = {data: {"1548806400000": 988,
                        // "1548892800000": 1443,
                        // "1548979200000": 1440,
                        // "1549065600000": 1440,
                        // "1549152000000": 1440,
                        // "1549238400000": 1440,
                        // "1549324800000": 728} };

                        let data = res['data'], dateLabels = [], totalData = [];
                        self.chartData = data;

                        var allDates = Object.keys(data);

                        for(let i in allDates){
                            if(allDates.hasOwnProperty(i)){
                                dateLabels.push(new Date(Number(allDates[i])).toDateString().substr(0,3));
                                totalData.push(data[allDates[i]]);
                            }
                        }
                        self.drawRequestsChart(dateLabels, totalData);
                    }
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.showNOData = true;
                // console.log("api failed with error: ", error);
            });

            // We should remove this added just for testing..
            // if(self.showAlertsChart){
            //     self.drawAlertsChart();
            // }else{
            //     self.drawRequestsChart();
            // }
        },
        drawAlertsChart(dateLabels, newData, retroData, totalData){
            var self = this;
            Chart.defaults.global.elements.line.fill = false;
            Chart.defaults.global.responsive = true;
            var ctx = document.getElementById("alertsChart").getContext("2d");
            self.barLineChart = new Chart(ctx, {
                type: 'bar',
                data: {
                labels: dateLabels || ["Sunday", "Monday", "Tuesday", "Thrusday", "Friday", "Saturday"],
                datasets: [{
                        label: "New",
                        type: "line",
                        borderColor: '#4f2e88',
                        backgroundColor: '#4f2e88',
                        data: newData || [100, 120, 110, 1216, 450, 3, 300],
                    }, {
                        label: "Retrospective",
                        type: "line",
                        borderColor: '#4679e1',
                        backgroundColor: '#4679e1',
                        data: retroData || [133, 221, 349, 247, 568, 236, 789],
                    },{
                        label: "Total",
                        type: "bar",
                        backgroundColor: '#ffa500',
                        data: totalData || [233, 341, 459, 1436, 1018, 239, 1089]
                    }
                ]
                },
                options: {
                    title: {
                        display: true,
                        // text: self.isalertchart ? 'Alerts Per Day' : 'Requests Per Day'
                    },
                    legend: { display: false },
                    scales:{
                        yAxes:[{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        },

        drawRequestsChart(dateLabels, totalData){
            var self = this;
            Chart.defaults.global.elements.line.fill = false;
            Chart.defaults.global.responsive = true;
            var ctx = document.getElementById("alertsChart").getContext("2d");
            self.barLineChart = new Chart(ctx, {
                type: 'bar',
                data: {
                labels: dateLabels || ["Sunday", "Monday", "Tuesday", "Wednesday", "Thrusday", "Friday", "Saturday"],
                datasets: [{
                        label: "New",
                        type: "line",
                        borderColor: '#4f2e88',
                        backgroundColor: '#4f2e88',
                        data: totalData || [17190, 18472, 18267, 1195, 1456, 1126, 8756],
                    }
                ]},
                options: {
                    title: {
                        display: true,
                        // text: self.isalertchart ? 'Alerts Per Day' : 'Requests Per Day'
                    },
                    legend: { display: false },
                    scales:{
                        yAxes:[{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        },
        showLoadIcon,
        hideLoadIcon

    }
}
</script>
